var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTurbine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2079,
    height: 2079,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 331,
    y: 580,
    width: 2079,
    height: 2079
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-331 -580)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 331,
    y: 580,
    width: 2079,
    height: 2079,
    fill: "#4472C4",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.33 833.683 2154.33 833.683 2154.33 2404.68 585.33 2404.68Z",
    fill: "#4472C4",
    fillRule: "evenodd",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.33 1618.68C740.33 1270.74 1022.17 988.683 1369.83 988.683 1717.49 988.683 1999.33 1270.74 1999.33 1618.68 1999.33 1966.62 1717.49 2248.68 1369.83 2248.68 1022.17 2248.68 740.33 1966.62 740.33 1618.68Z",
    fill: "#4472C4",
    fillRule: "evenodd",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.329 1619.18C842.329 1330.61 1078.72 1096.68 1370.33 1096.68 1661.94 1096.68 1898.33 1330.61 1898.33 1619.18 1898.33 1907.75 1661.94 2141.68 1370.33 2141.68 1078.72 2141.68 842.329 1907.75 842.329 1619.18Z",
    fill: "#222222",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.33 1619.18C1057.33 1445.49 1197.46 1304.68 1370.33 1304.68 1543.19 1304.68 1683.33 1445.49 1683.33 1619.18 1683.33 1792.87 1543.19 1933.68 1370.33 1933.68 1197.46 1933.68 1057.33 1792.87 1057.33 1619.18Z",
    fill: "#838282",
    fillRule: "evenodd"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurbine);
export default __webpack_public_path__ + "static/media/Turbine.2322415c6670c9f50fce9dc7b65c01cf.svg";
export { ForwardRef as ReactComponent };